import { useState, useEffect } from 'react'

function Legado() {
  const [datos, setDatos] = useState(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    if (!token) {
      setError('Enlace no válido. Verifica que copiaste el enlace completo.')
      setCargando(false)
      return
    }
    cargarLegado(token)
  }, [])

  async function cargarLegado(token) {
    try {
      const res = await fetch(`https://legado-digital-production.up.railway.app/api/legacy/${token}`)
      const data = await res.json()
      if (!data.ok) {
        setError(data.error || 'Enlace no válido o expirado')
        return
      }
      setDatos(data)
    } catch {
      setError('No se pudo cargar la información. Intenta de nuevo.')
    } finally {
      setCargando(false)
    }
  }

  const categoriaLabel = {
    email: 'Email', social: 'Red social', banking: 'Banco',
    streaming: 'Streaming', cloud_storage: 'Almacenamiento',
    work: 'Trabajo', shopping: 'Compras', gaming: 'Gaming', other: 'Otro'
  }

  if (cargando) {
    return (
      <div style={estilos.centrado}>
        <img src="/logo-etern-me.png" alt="Etern-me" style={estilos.logoCargando} />
        <p style={estilos.mensajeCargando}>Cargando información...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div style={estilos.centrado}>
        <img src="/logo-etern-me.png" alt="Etern-me" style={estilos.logoCargando} />
        <div style={estilos.errorCaja}>
          <h2 style={estilos.errorTitulo}>Enlace no válido</h2>
          <p style={estilos.errorTexto}>{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div style={estilos.pagina}>
      <div style={estilos.contenido}>

        <div style={estilos.header}>
          <img src="/logo-etern-me.png" alt="Etern-me" style={estilos.logoHeader} />
          <p style={estilos.headerSubtitulo}>
            Hola {datos.heredero.nombre}, esta es la información
            que te han dejado preparada con mucho amor.
          </p>
        </div>

        {datos.legado.suscripciones.length > 0 && (
          <div style={estilos.seccion}>
            <div style={estilos.seccionHeader}>
              <span style={estilos.seccionIcono}>💳</span>
              <h2 style={estilos.seccionTitulo}>Suscripciones activas a cancelar</h2>
            </div>
            <p style={estilos.seccionSubtitulo}>
              Estas suscripciones siguen activas. Cancélalas lo antes posible para evitar cargos.
            </p>
            {datos.legado.suscripciones.map((s, i) => (
              <div key={i} style={estilos.card}>
                <div style={estilos.cardFila}>
                  <span style={estilos.cardNombre}>{s.nombre}</span>
                  <span style={estilos.cardPrecio}>
                    {Number(s.coste_mensual).toFixed(2)} {s.moneda}/mes
                  </span>
                </div>
                {s.instruccion_heredero && (
                  <p style={estilos.cardInstruccion}>{s.instruccion_heredero}</p>
                )}
              </div>
            ))}
            <div style={estilos.totalCard}>
              <span style={estilos.totalLabel}>Total mensual a cancelar</span>
              <span style={estilos.totalValor}>
                {datos.legado.suscripciones
                  .reduce((t, s) => t + Number(s.coste_mensual), 0)
                  .toFixed(2)}/mes
              </span>
            </div>
          </div>
        )}

        {datos.legado.cuentas.length > 0 && (
          <div style={estilos.seccion}>
            <div style={estilos.seccionHeader}>
              <span style={estilos.seccionIcono}>🔐</span>
              <h2 style={estilos.seccionTitulo}>Cuentas digitales</h2>
            </div>
            <p style={estilos.seccionSubtitulo}>
              Accede a estas cuentas siguiendo las instrucciones indicadas.
            </p>
            {datos.legado.cuentas.map((c, i) => (
              <div key={i} style={estilos.card}>
                <div style={estilos.cardFila}>
                  <span style={estilos.cardNombre}>{c.nombre}</span>
                  <span style={estilos.categoria}>
                    {categoriaLabel[c.categoria] || 'Otro'}
                  </span>
                </div>
                {c.usuario_hint && (
                  <p style={estilos.hint}>Usuario: {c.usuario_hint}</p>
                )}
                {c.instruccion_heredero && (
                  <p style={estilos.cardInstruccion}>{c.instruccion_heredero}</p>
                )}
                <p style={estilos.accion}>
                  {c.accion_post_muerte === 'transfer' ? 'Transferir acceso'
                    : c.accion_post_muerte === 'delete' ? 'Eliminar cuenta'
                    : c.accion_post_muerte === 'memorialize' ? 'Mantener activa'
                    : 'Solo notificar'}
                </p>
              </div>
            ))}
          </div>
        )}

        {datos.legado.suscripciones.length === 0 && datos.legado.cuentas.length === 0 && (
          <div style={estilos.vacio}>
            <p>No hay información disponible en este momento.</p>
          </div>
        )}

        <div style={estilos.footer}>
          <img src="/logo-etern-me.png" alt="Etern-me" style={estilos.logoFooter} />
          <p style={estilos.footerTexto}>
            Este enlace es personal e intransferible.
          </p>
          <p style={estilos.footerCopy}>
            2026 ETERN-ME · Todos los derechos reservados · Creado por Melina Rivera
          </p>
        </div>

      </div>
    </div>
  )
}

const estilos = {
  pagina: {
    minHeight: '100vh',
    backgroundColor: '#FAF8F5',
    padding: '0 0 48px',
  },
  contenido: {
    maxWidth: '680px',
    margin: '0 auto',
    padding: '0 16px',
  },
  centrado: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    backgroundColor: '#FAF8F5',
  },
  logoCargando: {
    width: '80px',
    height: '80px',
    objectFit: 'contain',
    borderRadius: '50%',
    marginBottom: '16px',
  },
  mensajeCargando: {
    color: '#8B6F47',
    fontSize: '16px',
  },
  header: {
    textAlign: 'center',
    padding: '48px 24px 32px',
    marginBottom: '8px',
  },
  logoHeader: {
    width: '140px',
    height: '140px',
    objectFit: 'contain',
    borderRadius: '50%',
    marginBottom: '16px',
  },
  headerSubtitulo: {
    fontSize: '16px',
    color: '#8B6F47',
    lineHeight: '1.7',
    maxWidth: '480px',
    margin: '0 auto',
  },
  seccion: {
    marginBottom: '32px',
  },
  seccionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '8px',
  },
  seccionIcono: { fontSize: '20px' },
  seccionTitulo: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#2C1810',
  },
  seccionSubtitulo: {
    fontSize: '13px',
    color: '#8B6F47',
    marginBottom: '16px',
    lineHeight: '1.5',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '16px 20px',
    marginBottom: '10px',
    border: '1px solid #E8E0D5',
  },
  cardFila: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '6px',
    flexWrap: 'wrap',
    gap: '6px',
  },
  cardNombre: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#2C1810',
  },
  cardPrecio: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#5C6B3A',
  },
  cardInstruccion: {
    fontSize: '13px',
    color: '#8B6F47',
    margin: '4px 0 0',
    lineHeight: '1.5',
  },
  hint: {
    fontSize: '13px',
    color: '#8B6F47',
    margin: '4px 0 0',
  },
  accion: {
    fontSize: '12px',
    color: '#2C1810',
    fontWeight: '500',
    margin: '6px 0 0',
    backgroundColor: '#F0EAE0',
    padding: '4px 10px',
    borderRadius: '20px',
    display: 'inline-block',
  },
  categoria: {
    fontSize: '12px',
    backgroundColor: '#F0EAE0',
    color: '#8B6F47',
    padding: '3px 10px',
    borderRadius: '20px',
    fontWeight: '500',
  },
  totalCard: {
    backgroundColor: '#2C1810',
    borderRadius: '12px',
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
    flexWrap: 'wrap',
    gap: '8px',
  },
  totalLabel: {
    color: '#C4A882',
    fontSize: '13px',
  },
  totalValor: {
    color: '#FAF8F5',
    fontSize: '20px',
    fontWeight: '700',
  },
  vacio: {
    textAlign: 'center',
    color: '#8B6F47',
    padding: '48px 24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    border: '1px solid #E8E0D5',
    fontSize: '14px',
  },
  errorCaja: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '32px',
    textAlign: 'center',
    border: '1px solid #E8E0D5',
    maxWidth: '400px',
    marginTop: '16px',
  },
  errorTitulo: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#2C1810',
    marginBottom: '12px',
  },
  errorTexto: {
    fontSize: '14px',
    color: '#8B6F47',
    lineHeight: '1.6',
  },
  footer: {
    textAlign: 'center',
    marginTop: '48px',
    paddingTop: '24px',
    borderTop: '1px solid #E8E0D5',
  },
  logoFooter: {
    width: '60px',
    height: '60px',
    objectFit: 'contain',
    borderRadius: '50%',
    marginBottom: '8px',
  },
  footerTexto: {
    fontSize: '14px',
    color: '#9e835e',
    marginBottom: '4px',
  },
  footerCopy: {
    fontSize: '13px',
    color: '#9e835e',
  },
}

export default Legado